import {
  useGetUserAiAssessmentScales,
  useDeleteAiAssessmentScale,
  getGetUserAiAssessmentScalesQueryKey,
  useGetTopAiAssessmentScales,
  likeAiAssessmentScale,
  unlikeAiAssessmentScale,
  getGetTopAiAssessmentScalesQueryKey,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import AiAssessmentScaleCard from "../../components/ai-assessment-scale/AiAssessmentScaleCard";

const AiAssessmentScaleDetailComponent = ({
  tool,
}: {
  tool: any; // Use any temporarily to resolve type issues
}) => {
  return <AiAssessmentScaleCard assessmentScale={tool} />;
};

const AiAssessmentScaleView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserAiAssessmentScales}
      useDeleteTool={useDeleteAiAssessmentScale}
      getGetToolsQueryKey={getGetUserAiAssessmentScalesQueryKey}
      useGetTopTools={useGetTopAiAssessmentScales}
      likeTool={likeAiAssessmentScale}
      unlikeTool={unlikeAiAssessmentScale}
      getGetTopToolsQueryKey={getGetTopAiAssessmentScalesQueryKey}
      toolType="aiAssessmentScale"
      toolPath="ai-assessment-scale"
      DetailComponent={AiAssessmentScaleDetailComponent}
      colors={{
        light: "from-teal-500 to-teal-500",
        dark: "dark:from-teal-400 dark:to-teal-400",
        iconBg: "bg-teal-100 dark:bg-teal-900/50",
        iconColor: "text-teal-600 dark:text-teal-400",
        hover: "hover:bg-indigo-50 dark:hover:bg-indigo-900/20",
      }}
      toolColor="teal"
      gradientColor="teal"
    />
  );
};

export default AiAssessmentScaleView;
